<template>
  <div class="tab1 module_item">
    <div class="search">
      <el-cascader
        :options="v2CountryList"
        :props="propsNew"
        v-model="macroData.countryArray"
        @change="emitSearch"
        ref="cInput"
        placeholder="Country"
        class="module_search_select"
      ></el-cascader>
      <el-select
        v-model="macroData.rate"
        placeholder="allPeriod"
        class="module_search_select"
        @change="emitSearch"
      >
        <el-option
          v-for="item in allPeriod"
          :key="item.label"
          :label="item.label"
          :value="item.field"
        ></el-option>
      </el-select>
      <div class="resetBtn">
        <i class="el-icon-refresh" @click="resetCondiction" title="reset"></i>
        <!-- <el-button type="text" @click="resetCondiction">Reset</el-button> -->
      </div>
    </div>

    <div class="total-top">
      Total
      <span class="totalCls">{{total}}</span> records
    </div>
    <!--  -->
    <div class="list_resullt" v-if="lists.length">
      <!-- pc端 -->
      <el-checkbox-group v-model="checkList" @change="checkListChange" v-if="!isMobile">
        <div
          class="result_item"
          v-for="(item,index) of lists"
          :key="index"
          :class="{activeModuleCls:activeList.includes(item.id)}"
        >
          <el-checkbox :label="JSON.stringify(item)" :disabled="!!item.disabled">
            <div class="item_title">
              <span class="title">{{item.fullName}}</span>
              <slot name="tag" :item="item"></slot>
            </div>

            <div class="detail">
              <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
                <span class="tag_label">{{list.label}}:&nbsp &nbsp</span>
                <span class="tab_value">{{item[list.key]}}</span>
              </p>
            </div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
      <!-- 移动端 -->
      <div v-else>
        <div
          class="result_item"
          v-for="(item,index) of lists"
          :key="index"
          @click="searchData(item)"
        >
          <div class="item_title">
            <span class="title">{{item.fullName}}</span>
            <slot name="tag" :item="item"></slot>
          </div>

          <div class="detail">
            <p v-for="(list,j) of detailLists" :key="j" class="detail_item">
              <span class="tag_label">{{list.label}}:&nbsp &nbsp</span>
              <span class="tab_value">{{item[list.key]}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="list_resullt" v-else>
      <div class="noData no_data_container">
        <span class="img no_data_img"></span>
        <p>Sorry, No data was found</p>
      </div>
    </div>

    <div class="page_footer clearfix">
      <el-pagination
        :total="total"
        background
        layout="prev, pager, next"
        :current-page="macroData.page"
        :pager-count="5"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { allPeriod, allPeriodList } from "conf/macroSelect.js";

const detailLists = [
  {
    label: "Country/Region",
    key: "countryName" //后台字段
  },
  {
    label: "Frequency",
    key: "frequency" //后台字段
  },
  {
    label: "Unit",
    key: "unit" //后台字段
  },
  {
    label: "Data-Source",
    key: "resource" //后台字段
  }
];

export default {
  props: ["lists", "total"],
  data() {
    return {
      propsNew: {
        label: "enName",
        value: "enName"
      },
      allPeriod: allPeriodList,
      detailLists, //每个模块的字段不同
      list: [],
      checkList: [],

      macroData: {
        indexCore: 4,
        pageIndex: 1,
        pageSize: 10,
        rate: "年",
        countryArray: []
      },
      checkListLen: 0,
      activeList: []
    };
  },

  created() {},

  mounted() {
    this.emitSearch();
  },

  methods: {
    emitSearch() {
      let data = this.$lodash.cloneDeep(this.macroData);

      // 级联菜单获取的是数组  取最后一项
      let countryData;
      if (data.countryArray.length > 0) {
        countryData = data.countryArray[data.countryArray.length - 1];
        data = Object.assign(data, { countryArray: [countryData] });
      }
      //无数据时删除字段 后台接受会报错
      else {
        delete data.countryArray;
      }
      // else {
      //   countryData = "";
      //   data = Object.assign(data, { countryArray: [] });
      // }

      this.$emit("search", "macro", data);
    },

    //手机端
    searchData(item) {
      // this.$router.push({
      //   path: "/data/SearchModule/Industry"
      // });
      this.$emit("changRightStatus", "Macro", {
        name: item.name,
        countryName: item.countryName
      });
    },

    handleCurrentChange(val) {
      this.macroData.pageIndex = val;
      this.emitSearch();
    },

    checkListChange() {
      console.log(this.checkList);
      this.activeList = this.checkList.map(item => JSON.parse(item).id);
      // if (this.checkList.length > 1) {
      //   const typePre = JSON.parse(this.checkList[this.checkList.length - 2])
      //     .time;
      //   const typeCurrent = JSON.parse(
      //     this.checkList[this.checkList.length - 1]
      //   ).time;
      //   if (typeCurrent != typePre) {
      //     this.checkList.pop();
      //     this.$message({
      //       message: "Different Period Can not Compare !",
      //       type: "warning"
      //     });
      //   }
      // }
      // if (this.checkList.length > 1) {
      //   let hash = [];
      //   for (let item of this.checkList) {
      //     let unit = JSON.parse(item).unit;
      //     if (!hash.includes(unit)) {
      //       hash.push(unit);
      //       if (hash.length >= 2) {
      //         this.$message({
      //           message: "Different Period Can not Compare !",
      //           type: "warning"
      //         });
      //         bre
      //       }
      //     }
      //   }
      // }
      //没有数据权限
      if (!this.allKey.MACRO_DETAIL) {
        this.$message({
          message: "Sorry, there are no permissions !",
          type: "warning"
        });
      }
      //关闭主页显示
      this.changeIndexShow(false);
      this.setMacroListChecked(this.checkList);
    },

    resetCondiction() {
      this.macroData = {
        indexCore: 4,
        pageIndex: 1,
        pageSize: 10,
        rate: "年",
        countryArray: []
      };
      this.emitSearch();
    },

    ...mapMutations(["setMacroListChecked", "changeIndexShow"])
  },

  computed: {
    ...mapState({
      ListChecked(state) {
        return state.MacroChecked.ListChecked;
      },
      isMobile(state) {
        return state.MobileStatus.isMobile;
      },
      v2CountryList(state) {
        return state.v2Permission.v2CountryList;
      },
      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  },

  watch: {
    $attrs(newValue) {
      console.log("TCL: $attrs -> newValue", newValue);
    },
    ListChecked(newValue) {
      this.checkList = newValue;
      if (!newValue.length) {
        this.activeList = [];
      }
    }
  }
};
</script>

<style scoped>
.list_resullt {
  margin-top: 10px;
  height: calc(100% - 250px);
  overflow-y: auto;
  padding: 0px 10px 0px 0px;
}

.page_footer >>> .el-pagination {
  float: right;
}

.total_page {
  float: left;
  height: 32px;
  line-height: 32px;
}

.page_footer {
  border-top: 1px solid #dee2e6;
  padding-top: 16px;
}

.tag_label {
  display: inline-block;
  width: 130px;
}

.tab_value {
  display: inline-block;
  width: calc(100% - 130px);
  vertical-align: top;
}
.list_resullt >>> .el-checkbox {
  width: 100% !important;
}
.list_resullt >>> .el-checkbox .el-checkbox__input {
  position: absolute !important;
  right: 20px !important;
  top: 25px !important;
}
.module_search_select {
  width: 45% !important;
  margin-right: 1% !important;
}
</style>